export default __webpack_public_path__ + "5f503f767887a4e4b6efd3a610702cb5.png";